import { styled, Box } from '@mui/material';
import Button from '../../Button/Button.js';
import '../../Button/SplitButton.js';

const ElipsisButtonWrapper = styled(Button) `
  margin: 0 5px;
  min-width: 30px;
`;
const LabelWithDateContainer = styled(Box) `
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export { ElipsisButtonWrapper, LabelWithDateContainer };
//# sourceMappingURL=styles.js.map
